module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-01.970f1e58.png";